(function () {
    'use strict';

    angular.module('app.ctrls').controller('StampCtrl', stampCtrl);

    async function stampCtrl($scope, $routeParams, $window) {
        'ngInject';

        const { stampId, gclid, redirectTo } = $routeParams;

        if (stampId || gclid) {
            const url = new URL('/public/api/stamp', process.env.VUE_APP_SHOPIFY_PRODUCT_PERSONALIZER_BASE_URL);
            try {
                await fetch(url.toString(), {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        stampId: stampId ? String(stampId) : undefined,
                        gclid: gclid ? String(gclid) : undefined
                    })
                });
            } catch (error) {
                // Do not block redirect flow if stamp endpoint is temporarily unavailable.
                console.error('Failed to send stamp', error);
            }
        }

        setTimeout(function () {
            //timeout to leave enough time for GTM execution
            if (redirectTo) {
                const baseURL = process.env.VUE_APP_CUSTOMILY_BASE_URL;
                $window.location.href = `${baseURL}/signup?storeType=${redirectTo}`;
            } else {
                //added window.location.search to keep GTM query params
                $window.location.href = `https://apps.shopify.com/customily-product-personalizer${$window.location.search}`;
            }
        }, 500);
    }
})();
